import { render, staticRenderFns } from "./TotalDetailsDialog.vue?vue&type=template&id=23125024"
import script from "./TotalDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TotalDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./TotalDetailsDialog.vue?vue&type=style&index=0&id=23125024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports